export function visibleTabs(tabs) {
  return tabs.filter(item => item.visible !== false)
}
